import React from 'react'
import { CAlert } from '@coreui/react'

/* Port fiel de viewAnatomy de boston_ia (bindAnatomy era no-op: solo lectura).
   Mapa visual de los 6 archivos que componen el paquete + que hace cada uno. */

const TREE = `mi_script/                        ← la carpeta toma el nombre del script
├── index.html                    ← entry point que el agente abre por URL
├── app.js                        ← logica: lee data.json y arma el form
├── api.js                        ← wrapper que llama a Boston con el token
├── styles.css                    ← diseño del UI (Bootstrap 5 + Basset)
├── config_app.json               ← UUID unico del script (registro en Boston)
└── data.json                     ← definicion: forms, fields, commands`

const CONFIG_APP = `{
    "config": {
        "uuid": "a8841dd5-86e6-4950-b503-3bde54efe068",
        "useInternalConfig": true
    }
}`

const DATA_SCHEMA = `{
  "title": "AGREGAR REMARK OPERATIVO",          ← lo que ve el agente arriba
  "validateActiveReservation": true,            ← requiere PNR activo
  "sendCommands": false,                         ← true SOLO si hay postCommands
  "editCatalogues": false,
  "reintentos": 0,
  "enableMetrics": true,
  "messageinitial": "",                          ← mensaje opcional al abrir
  "viewCatalogues": false,
  "forms": [                                     ← uno o varios formularios (wizard)
    {
      "form": "form1", "title": "DATOS", "title_visible": true,
      "remarks": [                               ← cada remark = un field. 24 PROPIEDADES, EN ESTE ORDEN:
        {
          "tag": "centro_costo",                 ← nombre SEMANTICO (nunca field_0)
          "Code": "",
          "dato": "",                            ← valor por defecto / pre-fill
          "size": "md",                          ← sm | md | bg
          "skip": false,                         ← true = NO se auto-emite (para inputs que solo alimentan el mask de otro campo)
          "block": 5,                            ← prefijo GDS: 5=remark 6=received 9=phone 7=tkt 3=SSR/OSI
          "group": "DATOS *datos*",              ← "TITULO *slug*" (agrupa; ata fields a un button_menu)
          "index": 0,
          "label": "Centro de costo",            ← etiqueta visible
          "remark": "-CC-[centro_costo]",        ← [tag] se sustituye; block + remark = comando final
          "visible": true,
          "typedata": "select",                  ← text | number | select | date | checkbox | button_menu
          "campoForm": "centro_costo",           ← SIEMPRE igual a tag
          "data_test": "",
          "mandatory": true,
          "processed": false,
          "datasource": [                        ← opciones si es select (asi se comprime una tabla de IF)
            { "value": "CC001", "text": "Ventas LATAM" },
            { "value": "CC002", "text": "Marketing" }
          ],
          "multifield": false,
          "typeremark": "General",               ← General | Invoice | Itinerary | Historical | Ticket
          "coincidence": "",                     ← regex de validacion (obligatoria si no es texto libre)
          "remark_mask": "-CC-[centro_costo]",   ← con block=5 -> Sabre recibe "5-CC-CC001"
          "activeformat": true,
          "source_additional": []
        }
      ]
    }
  ],
  "postCommands": []                             ← comandos GDS y/o directivas {compute|if|read|loop}
}`

const RUNTIME_FLOW = `1. Agente hace click en el menu del script en Sabre Workspace
   ↓
2. Sabre abre  http://.../mi_script/index.html?token=ATH:...&env=stg
   ↓
3. index.html carga Bootstrap + styles.css + api.js + app.js
   ↓
4. app.js arranca, lee  config_app.json  y  data.json
   ↓
5. Si validateActiveReservation=true → callAPI('sabre/reservation')
   ↓
6. Por cada field de data.json.forms[].remarks renderiza un input
   ↓
7. Agente completa los campos → click "Revisar y Enviar"
   ↓
8. app.js arma los comandos: remark_mask + valor del field, para cada uno
   ↓
9. Click "Confirmar" → executeCommand(...) por cada comando
   ↓
10. Si hay postCommands, los ejecuta tambien (ER, *A, etc.)
   ↓
11. Modal de resultado: success / error`

function AnatomyView() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1>Anatomia del Custom Script</h1>
          <p>
            Cada Custom Script que generas es una <strong>carpeta con 6 archivos</strong>. Aca tenes el mapa visual y la
            explicacion de cada uno.
          </p>
        </div>
      </div>

      <div className="card-x">
        <h3>Estructura de la carpeta</h3>
        <pre className="bia-pre" style={{ background: '#0f172a', color: '#22d989', maxHeight: 'none' }}>{TREE}</pre>
        <CAlert color="info" className="mb-0 mt-3">
          <strong>Publicacion remota:</strong> ya operativa. “Publicar en ambiente actual” sube la carpeta
          completa a S3 como un release inmutable (<code>custom-scripts/&#123;uuid&#125;/releases/&#123;id&#125;/</code>)
          y actualiza la URL del script. Desde Revisión Dev también podés “Cargar S3 en editor”, modificar
          cualquier archivo y “Republicar tal cual”. Guardar en Biblioteca persiste en el backend Boston.
        </CAlert>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>📄 index.html — entry point</h3>
          <span className="bia-badge warn">se regenera por script</span>
        </div>
        <p>
          <strong>Que hace:</strong> es la pagina que Sabre Workspace abre en un panel. Carga Bootstrap, FontAwesome, los
          styles, y los dos scripts (api.js + app.js). Define el layout: header con titulo, step indicator (Validacion →
          Datos → Revisar → Resultado), el card del form, los modales (preview/processing/result/close-confirm) y el
          footer con UUID.
        </p>
        <p>
          <strong>Que personaliza por script:</strong> el <code>&lt;title&gt;</code>, el <code>headerTitle</code>, el{' '}
          <code>scriptNameBadge</code> y el <code>uuidBadge</code>. Todo lo demas es comun.
        </p>
        <p>
          <strong>Editar manualmente:</strong> solo si necesitas cambiar el layout base. Para 99% de los casos no se toca.
        </p>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>⚙ app.js — logica del script</h3>
          <span className="bia-badge ok">plantilla compartida</span>
        </div>
        <p>
          <strong>Que hace:</strong> es el cerebro del Custom Script. Al cargar la pagina:
        </p>
        <ol style={{ margin: '8px 0' }}>
          <li>
            Lee <code>data.json</code> y <code>config_app.json</code>
          </li>
          <li>
            Si <code>validateActiveReservation: true</code>, llama <code>GET /sabre/reservation</code> para confirmar que
            hay PNR activo
          </li>
          <li>
            Si <code>accessByDK: true</code>, valida el DK del agente contra la lista <code>allowedDKs</code>
          </li>
          <li>
            Renderiza el form dinamicamente: por cada field de <code>data.json</code>, crea un input segun su{' '}
            <code>typedata</code> (text/select/date/checkbox/etc) con su <code>label</code> y <code>mandatory</code>
          </li>
          <li>
            Cuando el agente da "Revisar y Enviar", muestra el preview con el comando GDS exacto que se va a ejecutar (
            <code>remark_mask</code> + valor del field)
          </li>
          <li>
            Al confirmar, ejecuta los comandos contra Sabre via <code>api.js</code>
          </li>
        </ol>
        <p>
          <strong>Editar manualmente:</strong> nunca. Es la misma para todos los scripts; si lo modificas, todos los
          scripts que comparten esta plantilla cambian.
        </p>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>🔌 api.js — wrapper del backend Boston</h3>
          <span className="bia-badge ok">plantilla compartida</span>
        </div>
        <p>
          <strong>Que hace:</strong> envuelve todas las llamadas a <code>boston.basset.ws</code> en una funcion{' '}
          <code>callAPI(endpoint, method, body)</code>. Lee el <code>?token=...</code> de la URL y lo manda como header.
          Define los wrappers amigables:
        </p>
        <ul style={{ margin: '8px 0' }}>
          <li>
            <code>readReservation()</code> → GET /sabre/reservation
          </li>
          <li>
            <code>readRemarks()</code> → GET /sabre/remarks
          </li>
          <li>
            <code>addRemarks(arr)</code> → POST /sabre/addremarks
          </li>
          <li>
            <code>modifyRemarks(arr)</code>, <code>deleteRemarks(arr)</code>
          </li>
          <li>
            <code>executeCommand(cmd)</code> → ejecuta un comando GDS
          </li>
          <li>
            <code>getCataloguesPCC(pcc, uuid)</code> → trae los catalogos disponibles para esa PCC
          </li>
          <li>
            <code>readDK()</code> → lee el DK del agente actual
          </li>
        </ul>
        <p>
          <strong>Editar manualmente:</strong> solo si agregas nuevos endpoints al backend Boston que tu script necesita.
        </p>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>🎨 styles.css — diseño</h3>
          <span className="bia-badge ok">plantilla compartida</span>
        </div>
        <p>
          <strong>Que hace:</strong> estilos del Custom Script: paleta Basset (verde #22d989), tipografias Inter,
          animaciones de step indicator, estilos de los modales, tarjetas, alerts, badges.
        </p>
        <p>
          <strong>Editar manualmente:</strong> si tu script necesita un look distinto (logos diferentes, otra paleta).
        </p>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>🪪 config_app.json — identidad del script</h3>
          <span className="bia-badge warn">unico por script</span>
        </div>
        <p>
          <strong>Que contiene:</strong>
        </p>
        <pre className="bia-pre" style={{ maxHeight: 'none' }}>{CONFIG_APP}</pre>
        <p>
          <strong>Por que importa el UUID:</strong> es el identificador unico del script en el backend Boston. Boston usa
          el UUID para:
        </p>
        <ul>
          <li>Saber a que PCC / parent PCC esta asignado el script</li>
          <li>Auditar quien lo ejecuto y cuando</li>
          <li>Vincular catalogos personalizados (centros de costo, aprobadores, etc.)</li>
        </ul>
        <p>
          <strong>Editar manualmente:</strong> el UUID solo se regenera si querés un script "limpio" sin asociaciones
          previas. Si lo cambias, perdes la vinculacion con PCC en Boston.
        </p>
      </div>

      <div className="card-x">
        <div className="bia-card-head">
          <h3>📋 data.json — la definicion completa del script</h3>
          <span className="bia-badge warn">unico por script</span>
        </div>
        <p>
          <strong>Que contiene:</strong> es <strong>el corazon del Custom Script</strong>. Define:
        </p>
        <pre className="bia-pre" style={{ maxHeight: 'none' }}>{DATA_SCHEMA}</pre>
        <p>
          <strong>Schema EXACTO de produccion</strong> — los 3 agentes IA lo conocen de por sí (vive en el prompt del
          Agente 3): <strong>24 propiedades por remark, en ese orden</strong>, <code>tag</code>===<code>campoForm</code>{' '}
          semánticos, y <code>block</code> separado del <code>remark_mask</code>. No existen <code>scriptType</code>/
          <code>orderExecute</code>/<code>targetEnv</code>.
        </p>
        <p>
          <strong>Patrones de compresión que aplican los agentes:</strong> tabla de <code>IF</code>/menú que solo elige un
          valor → UN <code>select</code> con <code>datasource</code>; cálculos (<code>[x]=[y]*[z]</code>) → directivas{' '}
          <code>{'{compute}'}</code> en <code>postCommands</code>; lectura del PNR (EMUFIND) → <code>prefillFromPnr</code>;
          auto-datos → <code>[@INITIALS]</code>/<code>[@DATE]</code>/<code>[@PNR]</code>.
        </p>
        <p>
          <strong>Editar manualmente:</strong> SI. Es lo que mas vas a tocar. Usa el <strong>Custom Script Builder</strong>{' '}
          para no escribir el JSON a mano.
        </p>
      </div>

      <div className="card-x">
        <h3>🔁 Flujo runtime cuando el agente abre el script</h3>
        <pre className="bia-pre" style={{ background: '#0f172a', color: '#cbd5e1', maxHeight: 'none' }}>{RUNTIME_FLOW}</pre>
      </div>
    </>
  )
}

export default AnatomyView
